import React, { useState } from 'react';
import { converteData2 } from '../../../../../../app/modules/helpers/helpers';
import ActionPlanResourceEdition from './ActionPlanResourceEdition';

type Props = {
  data: any,
  action_id: any,
  action_plan_id: any,
}

const ActionPlanListResource: React.FC<Props> = ({...props}) => {

  const [openModalResource, setOpenModalResource] = useState(false);
  const [id, setId] = useState('');

  return(
    <>
      <ActionPlanResourceEdition
        title='Edit a resource'
        action_id={props.action_id}
        action_plan_id={props.action_plan_id}
        id={id}
        onAction={()=>{}}
        showModal={openModalResource}
        onClose={()=>setOpenModalResource(false)}
      />
      {
        props.data.map((item: any, index: any)=> 
          <div key={index} className='accordion mb-1' id={`kt_accordion_${index+30}`}>
            <div className='accordion-item'>
              <h2 className='accordion-header' id={`kt_accordion_1_header_${index+30}`}>
                <button
                  className='accordion-button fs-4 fw-bold collapsed'
                  type='button'
                  data-bs-toggle='collapse'
                  data-bs-target={`#kt_accordion_1_body_${index+30}`}
                  aria-expanded='false'
                  aria-controls={`kt_accordion_1_body_${index+30}`}
                >
                  Monitoring #{index+1}
                </button>
              </h2>
              <div
                id={`kt_accordion_1_body_${index+30}`}
                className='accordion-collapse collapse'
                aria-labelledby={`kt_accordion_1_header_${index+30}`}
                data-bs-parent={`#kt_accordion_${index+30}`}
              >
                <div className='accordion-body'>
                  
                  <div className='col-lg-12'>
                    <div className='row fv-row'>
                      <div className='col-lg-6 d-flex flex-column'>
                        <span className='text-dark fs-5 fw-bolder'>Date</span>
                        <span className='text-gray-700 fs-6'>{converteData2(item.data)}</span>
                      </div>
                      <div className='col-lg-6 d-flex flex-column'>
                        <span className='text-dark fs-5 fw-bolder'>Status</span>
                        <span className='text-gray-700 fs-6'>
                          {
                            item.status === 1
                            ? 'Yes'
                            : 'No'
                          }
                        </span>
                      </div>
                      <div className='col-lg-12 d-flex flex-column mt-3'>
                        <span className='text-dark fs-5 fw-bolder'>Desctiption</span>
                        <span className='text-gray-700 fs-6'>
                          {item.description}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className='w-100 d-flex justify-content-end'>
                    <button onClick={()=>[setId(item.id),setOpenModalResource(true)]} className='btn btn-sm btn-primary'>
                      Edit
                    </button>
                  </div>

                </div>
              </div>
            </div>
          </div>
        )
      }
    </>
  )
}

export default ActionPlanListResource;